<template>
  <div class="question-row">
    <h4>Domanda #{{ index + 1 }}</h4>
    <div class="row">
      <input-text :name="`question-type-${index}`" width="6" label="Titolo" required :readonly="isShow" v-model="question.title"></input-text>
      <input-select
        :name="`question-type-${index}`"
        width="6"
        label="Tipo di domanda"
        :disabled="isShow"
        :options="questionTypesOptions"
        required
        v-model="question.type"
      ></input-select>

      <input-select
        v-if="question.type == 2"
        :name="`question-mft-attribute-${index}`"
        label="Campo MFT associato"
        :disabled="isShow"
        :options="mftAttributesOptions"
        required
        v-model="question.mft_attribute"
      ></input-select>

      <input-select
        v-if="question.type == 3"
        :name="`question-profile-update-${index}`"
        label="Campo profilo associato"
        :disabled="isShow"
        :options="profileAttributesOptions"
        required
        v-model="question.profile_attribute"
      ></input-select>

      <input-text :name="`question-description-${index}`" width="12" label="Descrizione" required :readonly="isShow" v-model="question.description"></input-text>

      <input-checkbox
        v-if="question.type != 3"
        :name="`question-multi-answers-${index}`"
        width="12"
        label="Risposta multipla"
        :disabled="isShow"
        v-model="question.multiple_answer"
      ></input-checkbox>
    </div>

    <div class="alert alert-warning" v-if="!isShow && question.type == 1">
      Se sono presenti più tag uguali per una risposta, il punteggio considerato sarà il più alto tra quelli inseriti.
    </div>

    <div class="answers-container" v-if="question.type != 3">
      <h4>Risposte:</h4>
      <div v-for="(answer, aIndex) in question.answers" :key="aIndex" class="answer-content">
        <div class="row">
          <input-text :name="`question-${index}-answer-${aIndex}`" placeholder="Risposta" required :readonly="isShow" v-model="answer.text"></input-text>

          <template v-if="question.type == 1">
            <div v-for="(tagVal, tIndex) in answer.tagValues" :key="tIndex">
              <input-select
                width="6"
                placeholder="Seleziona tag"
                :name="`question-${index}-answer-${aIndex}-tag-${tIndex}`"
                :disabled="isShow"
                required
                :options="tagsOptions"
                v-model="tagVal.tag"
              ></input-select>

              <input-number
                width="5"
                :name="`question-${index}-answer-${aIndex}-value-${tIndex}`"
                placeholder="Punteggio tag"
                required
                :readonly="isShow"
                v-model="tagVal.value"
              ></input-number>

              <div class="col-md-1">
                <button v-if="answer.tagValues.length > 1 && !isShow" type="button" class="btn btn-sm btn-danger" @click="$emit('remove-tag-value', aIndex, tIndex)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>

            <div class="col-md-12" style="margin-bottom: 20px">
              <button v-if="!isShow" type="button" class="btn btn-xs btn-warning" @click="$emit('add-tag-value', aIndex)">
                Aggiungi tag
              </button>
            </div>
          </template>
        </div>
        <button v-if="question.answers.length > 1 && !isShow" type="button" class="btn btn-sm btn-warning" @click="$emit('remove-answer', aIndex)">
          <i class="fa fa-trash"></i>
        </button>
      </div>

      <button v-if="!isShow" type="button" class="btn btn-sm btn-primary" @click="$emit('add-answer')">Aggiungi risposta</button>
    </div>

    <button v-if="!isShow" type="button" class="btn btn-sm btn-danger" id="btn-remove-question" @click="$emit('remove-question')"><i class="fa fa-trash"></i></button>
  </div>
</template>

<script>
export default {
  props: {
    isShow: Boolean,
    question: {
      type: Object,
      required: true,
    },
    index: Number,
    tagsOptions: {
      type: Array,
      default: () => [],
    },
    questionTypesOptions: {
      type: Array,
      default: () => [],
    },
    mftAttributesOptions: {
      type: Array,
      default: () => [],
    },
    profileAttributesOptions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.question-row {
  position: relative;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.input-question {
  margin-bottom: 10px;
}

#btn-remove-question {
  position: absolute;
  top: 15px;
  right: 15px;
}

.answers-container {
  padding: 15px;
  background-color: #f2f2f2;
}

.answers-container .row {
  width: 100%;
}

.answer-content {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

h4 {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/questionRow.vue